import axios from 'axios';

export const StatisticsService = {
  async getSalesStatistics() {
    const res = await axios.get('org/v1/reports/boughts/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
